export default (function (value) {
    /**
     * isObject({}) => true
     * isObject([1, 2, 3]) => true
     * isObject(Function) => true
     * isObject(null) => false
     */
    var type = typeof value;
    return value !== null && type === 'object' || type === 'function';
});
//# sourceMappingURL=is-object.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-object.js
// module id = 81
// module chunks = 3